exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-7a70bc50] {\n  width: 90%;\n  height: 100%;\n}\n.modal-content .image[data-v-7a70bc50] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  overflow: hidden;\n}\n.modal-content .image img[data-v-7a70bc50] {\n  width: auto;\n  max-height: 100%;\n}", ""]);

// exports
